module.exports = __webpack_public_path__ + "static/media/white-dress.10c32452.jpg";